import { render, staticRenderFns } from "./pool-list.vue?vue&type=template&id=71096d26&scoped=true&"
import script from "./pool-list.vue?vue&type=script&lang=ts&"
export * from "./pool-list.vue?vue&type=script&lang=ts&"
import style0 from "./pool-list.vue?vue&type=style&index=0&id=71096d26&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71096d26",
  null
  
)

export default component.exports